import { render } from "./Price.vue?vue&type=template&id=1d926d3a&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=1d926d3a&scoped=true&lang=css&external"
import "./Price.vue?vue&type=style&index=1&id=1d926d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d926d3a"]])

export default __exports__